import {TThingyView} from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI, requestScanFromAPI, requestRuleScanMasterFromAPI, requestUpdateActivationFromAPI, requestUpdateDeactivationFromAPI, requestArchiveFromAPI, requestUnarchiveFromAPI} from '../thunk/table_tunc';
import { parameterset } from '../typing/table_typing';

interface OwnProps {
    id:string
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        data:state.UpdateData.model, //state.UpdateData.model,
        scanmasterlist:"false",
        visible: false,
        condition: true,
        itemToDelete: "null",
        view:state.UpdateData.view,      
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
        onDeleteRequested:(item:string)=>{
           // dispatch(requestDataDeletionFromAPI(item) as any);
        },
        onMySubmit:(uuid:string)=>{
            dispatch(requestUpdateActivationFromAPI(uuid) as any)
        },
        onDeactivate:(uuid:string)=>{
            dispatch(requestUpdateDeactivationFromAPI(uuid) as any)
        },
        onArchive:(uuids:readonly string[], conflictText:string)=>{
            dispatch(requestArchiveFromAPI(uuids, conflictText) as any)
        },
        onRestore:(uuid:string)=>{
            dispatch(requestUnarchiveFromAPI(uuid) as any)
        },
        onScanRequested:(targetuuid:string, scanmasteruuid:string, parameter:parameterset)=>{
            dispatch(requestScanFromAPI(targetuuid, scanmasteruuid, parameter) as any); 
        },
        onRuleScanMasterRequested:(filter:string)=>{
            dispatch(requestRuleScanMasterFromAPI(filter) as any); 
        }
        
    }
}


const UpdateContainer=connect(mapStateToProps, bindDispatchToActions)(TThingyView);
export default UpdateContainer;